import { FC, ReactNode } from 'react';

import { HeaderCell } from '../../HeaderCell';

export interface HeaderProps {
  children?: ReactNode;
}

export const Header: FC<HeaderProps> = ({ children }) => <HeaderCell>{children}</HeaderCell>;
